export default __webpack_public_path__ + "img/default-coupon.de01efc8.jpg";